import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionTitle } from "./Reveal";
import { useT } from "../../i18n/LangContext";

export const Faq = () => {
  const t = useT().faq;
  return (
    <section id="faq" className="scroll-mt-16 bg-white px-5 py-16 sm:px-8 lg:py-20" data-testid="faq-section">
      <Reveal className="mx-auto max-w-7xl">
        <SectionTitle>{t.title}</SectionTitle>
        <Accordion type="single" collapsible className="mt-8 max-w-3xl border-t border-black/15">
          {t.items.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-black/15">
              <AccordionTrigger className="py-5 text-left text-base font-medium text-black hover:no-underline sm:text-lg [&>svg]:text-black" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-relaxed text-zinc-600" data-testid={`faq-answer-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};
